import React from 'react'
import classes from './TypesSection.module.sass'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'
import { equipmentTypes, transportLoadCapacities, transportSideTypes, transportTypes } from '../../utils/constants'

type Props = {
  item: TransportItemInterface | SlotItemInterface | CargoItemInterface
}

export const TypesSection = ({ item }: Props) => {
  return (
    <div className={classes.Container}>
      {item.transport_types.map((el) => transportTypes.find((item) => item.id === el)?.name)}
      <span />
      {item.transport_load_capacities.map(
        (el) => transportLoadCapacities.find((item) => item.id === el)?.name,
      )}
      <span />
      {item.transport_side_types.map(
        (el) => transportSideTypes.find((item) => item.id === el)?.name,
      )}
      <span />
      {item.equipment_types.map((el) => `${equipmentTypes.find((item) => item.id === el)?.name} `)}
    </div>
  )
}
